'use strict';
const { createAddQueries } = require('../addQueries');
const {
  id,
  payerId,
  userId,
  recipientId,
  externalDdaId,
  ddaId,
  scheduledTransactionId,
  createFilterConfig,
} = require('./commons');

module.exports = createAddQueries({
  returnModel: {
    name: 'importantmessage',
  },
  finders: [
    id,
    userId,
    payerId,
    recipientId,
    externalDdaId,
    ddaId,
    scheduledTransactionId,
    createFilterConfig('eventType', 'eventtype', 'string'),
    createFilterConfig('eventName', 'eventname', 'string'),
    createFilterConfig('module', 'module', 'string'),
    createFilterConfig('status', 'status', 'string'),
    createFilterConfig('activeOnly', 'activeonly', 'string'),
  ],
  orderBy: [
    id,
    userId,
    payerId,
    recipientId,
    externalDdaId,
    ddaId,
    scheduledTransactionId,
    createFilterConfig('status', 'status'),
    createFilterConfig('activeOnly', 'activeonly'),
  ],
});
